import CardPost from "../../components/cards/card-post"
import CardWritePost from "../../components/cards/card-write-post"
import "../../css/post/userPosts.css"
const UserPost = () => {
    return (
        <div className="container-user-post">
            <CardWritePost />
            <CardPost user="Melvin Jay" message="Lo Mejor de hoy" imageUser="https://play-lh.googleusercontent.com/uhwLDyRPKS8__hZPX-8OmVX0BFV_CBh9GKwZNQREKPuQk9xVPznce_UqIJINz0kfULo"/>
            <CardPost user="Melvin Jay" message="Lo Mejor de hoy" imageUser="https://play-lh.googleusercontent.com/uhwLDyRPKS8__hZPX-8OmVX0BFV_CBh9GKwZNQREKPuQk9xVPznce_UqIJINz0kfULo"/>
            <CardPost user="Melvin Jay" message="Lo Mejor de hoy" imageUser="https://play-lh.googleusercontent.com/uhwLDyRPKS8__hZPX-8OmVX0BFV_CBh9GKwZNQREKPuQk9xVPznce_UqIJINz0kfULo"/>
            <CardPost user="Melvin Jay" message="Lo Mejor de hoy" imageUser="https://play-lh.googleusercontent.com/uhwLDyRPKS8__hZPX-8OmVX0BFV_CBh9GKwZNQREKPuQk9xVPznce_UqIJINz0kfULo"/>
            <CardPost user="Melvin Jay" message="Lo Mejor de hoy" imageUser="https://play-lh.googleusercontent.com/uhwLDyRPKS8__hZPX-8OmVX0BFV_CBh9GKwZNQREKPuQk9xVPznce_UqIJINz0kfULo"/>
            <CardPost user="Melvin Jay" message="Lo Mejor de hoy" imageUser="https://play-lh.googleusercontent.com/uhwLDyRPKS8__hZPX-8OmVX0BFV_CBh9GKwZNQREKPuQk9xVPznce_UqIJINz0kfULo"/>
        </div>
    )
}

export default UserPost;